import { createElement, useEffect, useRef, useState } from 'react';
import { EditableProTable } from '@ant-design/pro-components';
import { Button as AButton, Card, Form, message, Input, Select, DatePicker, TimePicker, Popconfirm, Space } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import ImportExcelButton from './components/ImportExcelButton';
import ExportExcelButton from './components/ExportExcelButton';
const EditProTable = ({ tableName, columns = [], dataSource = [], exportButton, importButton, importTemplateList, tableHeaderBold, tableHeaderSize, rowKey, screen_inner_id, bind_inner_field = 'selected_flag', headerTitle, toolBarRender, scroll = {}, loading = false, rowCheck = false, pagination, actionColumnProps, onSubmit, ...otherProps }) => {
    const actionRef = useRef();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [editableKeys, setEditableRowKeys] = useState([]);
    const [originalColumns, setOriginalColumns] = useState([]);
    const [tableDataSource, setTableDataSource] = useState([]);
    const [originalDataSource, setOriginalDataSource] = useState([]);
    const [form] = Form.useForm();
    const screenStructure = screen_inner_id ? screen_inner_id.split('__')[1] : '';
    console.log('editProTable otherProps', otherProps);
    console.log('dataSource', dataSource);
    const generateProTableColumns = (columns) => {
        columns.forEach((column, index) => {
            if (column.hasCheckbox)
                return;
            column.title = (createElement("span", null,
                column.title,
                column.required ? createElement("span", { style: { color: 'red', marginLeft: 5 } }, "*") : null));
            column.renderFormItem = () => {
                const disabled = column.disableEdit;
                if (column.valueType === 'date') {
                    return createElement(DatePicker, { disabled: disabled });
                }
                if (column.valueType === 'time') {
                    return createElement(TimePicker, { disabled: disabled });
                }
                if (column.valueType === 'select') {
                    return createElement(Select, { disabled: disabled, options: column.valueEnum ? Object.keys(column.valueEnum).map((key) => ({ label: key, value: key })) : [] });
                }
                return createElement(Input, { disabled: disabled });
            };
            column.render = (node, row) => node;
            column.hasCheckbox = true;
        });
    };
    const extraColumns = [
        {
            title: 'ID',
            dataIndex: 'id',
            width: 100,
            fixed: 'left',
            hideInTable: true,
        },
        {
            title: actionColumnProps?.title || '操作',
            valueType: 'option',
            width: actionColumnProps?.width || 150,
            fixed: actionColumnProps?.fixed || false,
            render: (text, record, _, action) => [
                createElement("a", { key: "editable", onClick: () => {
                        action?.startEditable?.(record[rowKey]);
                    } }, "\u7F16\u8F91"),
                createElement(Popconfirm, { key: "delete", title: "\u786E\u5B9A\u5220\u9664\u6B64\u884C\u5417\uFF1F", onConfirm: () => handleDelete(record) },
                    createElement("a", { style: { color: '#ff4d4f' } }, "\u5220\u9664")),
            ],
        },
    ];
    useEffect(() => {
        console.log('columns', columns);
        setOriginalColumns(columns);
        if (dataSource.length) {
            const convertedDataSource = convertTimeData(dataSource, 'moment');
            setTableDataSource(convertedDataSource);
            setOriginalDataSource(JSON.parse(JSON.stringify(convertedDataSource)));
            setSelectedRowKeys([]);
            window.selectedRowKeys = [];
        }
    }, [dataSource]);
    const omit = (obj, keys) => {
        const result = { ...obj };
        keys.forEach(key => delete result[key]);
        return result;
    };
    const compareAndMarkStatus = (newData) => {
        let markedData = newData.map(row => {
            const originalRow = originalDataSource.find(origin => origin.id === row.id);
            if (!originalRow) {
                return { ...row, inner_status: 'add' };
            }
            const columnDataIndices = originalColumns
                .map(col => col.dataIndex)
                .filter((dataIndex) => dataIndex !== undefined);
            const currentData = {};
            const originalData = {};
            columnDataIndices.forEach(key => {
                const columnItem = originalColumns.find(col => col.dataIndex === key);
                if (columnItem && ['date', 'time'].includes(columnItem.valueType || '')) {
                    currentData[key] = row[key] ? moment.isMoment(row[key]) ? row[key] : moment(row[key]) : null;
                    originalData[key] = originalRow[key] ? moment.isMoment(originalRow[key]) ? originalRow[key] : moment(originalRow[key]) : null;
                }
                else {
                    currentData[key] = row[key];
                    originalData[key] = originalRow[key];
                }
            });
            const hasChanged = JSON.stringify(currentData) !== JSON.stringify(originalData);
            return hasChanged ? { ...row, inner_status: 'edit' } : row;
        });
        const deletedRows = originalDataSource
            .filter(origin => !newData.find(row => row.id === origin.id))
            .map(origin => {
            if (origin.inner_status === 'add') {
                return null;
            }
            return { ...origin, inner_status: 'delete' };
        })
            .filter(Boolean);
        markedData = [...markedData, ...deletedRows];
        markedData.forEach((row, rowIndex) => {
            Object.keys(row).forEach(columnKey => {
                const columnItem = columns.find(col => col.dataIndex === columnKey);
                if (columnItem && columnItem.valueType === 'date' && typeof row[columnKey] === 'string') {
                    markedData[rowIndex][columnKey] = moment(row[columnKey]);
                }
                if (columnItem && columnItem.valueType === 'time' && typeof row[columnKey] === 'string') {
                    markedData[rowIndex][columnKey] = moment(row[columnKey]);
                }
                if (rowCheck && bind_inner_field) {
                    markedData[rowIndex][bind_inner_field] = window.selectedRowKeys.includes(row[rowKey]) ? 'x' : '';
                }
            });
        });
        return markedData;
    };
    const handleColumnCheckboxChange = (event, column) => {
        console.log('handleColumnCheckboxChange', event, column);
        const { checked } = event.target;
        if (!(column.dataIndex || column.key))
            return;
        const currentSelectedColumns = checked ?
            [...selectedColumns, (column.dataIndex || column.key)] :
            selectedColumns.filter(key => key !== (column.dataIndex || column.key));
        setSelectedColumns(currentSelectedColumns);
    };
    const convertTimeData = (data, toType = 'moment') => {
        return data.map(row => {
            const newRow = { ...row };
            Object.keys(newRow).forEach(key => {
                const col = columns.find(c => c.dataIndex === key);
                if (!col || !['time', 'date'].includes(col.valueType))
                    return;
                const value = newRow[key];
                if (toType === 'moment') {
                    if (!value || value === '') {
                        newRow[key] = null;
                    }
                    else if (typeof value === 'string') {
                        const format = col.valueType === 'time' ? 'HH:mm:ss' : 'YYYY-MM-DD HH:mm:ss';
                        const m = moment(value, format, true);
                        newRow[key] = m.isValid() ? m : null;
                    }
                }
            });
            return newRow;
        });
    };
    const handleUpdateData = (data, changeTableData = true) => {
        const newData = JSON.parse(JSON.stringify(data));
        if (changeTableData) {
            setTableDataSource(newData);
        }
        let markedData = compareAndMarkStatus(newData);
        console.log('markedData', markedData);
        if (!screenStructure)
            return;
        screenStructure && window.screenStructures && (window.screenStructures[screenStructure] = markedData);
    };
    const handleSave = async (key, row) => {
        console.log('handleSave row', row);
        console.log('handleSave originalColumns', originalColumns);
        originalColumns.forEach(columnItem => {
            const title = typeof columnItem.title === 'object' ? columnItem.title?.props?.children?.[0] : columnItem.title;
            if (columnItem && columnItem.required && !row[columnItem.dataIndex]) {
                message.error(`字段 ${title} 是必填项`);
                throw new Error(`字段 ${title} 是必填项`);
            }
        });
        const newData = JSON.parse(JSON.stringify(tableDataSource));
        const { index, ...restRow } = row;
        const rowIndex = newData.findIndex(item => item.id === key);
        if (rowIndex > -1) {
            newData[rowIndex] = restRow;
        }
        else {
            newData.push(restRow);
        }
        handleUpdateData(newData);
    };
    const handleDelete = (record) => {
        const newData = tableDataSource.filter(item => item.id !== record.id);
        handleUpdateData(newData);
    };
    const handleAdd = () => {
        const newRow = {
            id: (Math.random() * 1000000).toFixed(0),
        };
        actionRef.current?.addEditRecord?.(newRow);
    };
    const handleRowChange = async (key, row) => {
        setSelectedRowKeys(key);
        window.selectedRowKeys = key;
        setTimeout(() => {
            const newData = JSON.parse(JSON.stringify(tableDataSource));
            handleUpdateData(newData);
        }, 500);
    };
    const handleImport = async (response) => {
        if (!response || !response.columns || !response.data || !response.data.length)
            return;
        const newData = response.data.map((item, index) => ({
            id: index,
            ...item,
        }));
        const newColumns = response.columns;
        setOriginalColumns(newColumns);
        setTableDataSource(newData);
        setOriginalDataSource(newData);
        if (!screenStructure)
            return;
        screenStructure && window.screenStructures && (window.screenStructures[screenStructure] = newData);
    };
    let tableClassName = 'edit-pro-table';
    if (tableHeaderBold) {
        tableClassName += ' th-bold';
    }
    if (tableHeaderSize) {
        tableClassName += ` th-font-${tableHeaderSize}`;
    }
    generateProTableColumns(originalColumns);
    return (createElement(Card, { bordered: false, bodyStyle: { padding: 0 }, style: { width: '100%' } },
        (exportButton || importButton) && createElement(Card, { bordered: false, bodyStyle: { padding: '0 0 12px' } },
            createElement(Space, null,
                exportButton && createElement(ExportExcelButton, { tableDataSource: tableDataSource, columns: originalColumns, tableName: tableName }),
                importButton && createElement(ImportExcelButton, { importTemplateList: importTemplateList, onImport: handleImport }))),
        createElement(EditableProTable, { ...otherProps, rowKey: rowKey, rowSelection: rowKey && rowCheck ? {
                selectedRowKeys,
                onChange: handleRowChange,
            } : false, actionRef: actionRef, headerTitle: headerTitle, recordCreatorProps: false, search: false, columns: [
                ...originalColumns,
                ...extraColumns,
            ], value: tableDataSource, loading: loading, editable: {
                form,
                editableKeys,
                onSave: handleSave,
                onChange: setEditableRowKeys,
                actionRender: (row, config, dom) => [dom.save, dom.cancel],
            }, scroll: scroll, pagination: {
                showSizeChanger: true,
                showQuickJumper: true,
                ...pagination,
                defaultPageSize: 10,
                showTotal: (total) => `共 ${total} 条数据`,
                pageSizeOptions: ['10', '20', '30', '50', '100'],
            }, className: tableClassName }),
        createElement(Card, { bordered: false, bodyStyle: { padding: '0 0 40px' }, style: { width: '100%' } },
            createElement(AButton, { type: "dashed", onClick: handleAdd, icon: createElement(PlusOutlined, null), block: true }, "\u65B0\u589E\u4E00\u884C"))));
};
export default EditProTable;
